import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Mídia',
        path: '/biblioteca/bibmidia',
        name: 'bibmidia',
        component: () => import('@/views/biblioteca/bibmidia/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_TIPOSDEMIDIANOVO_MENU_1300800299],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Midia',
        path: '/biblioteca/bibmidia/cadastro/:id?',
        parent: 'bibmidia',
        name: 'bibmidia_create',
        component: () => import('@/views/biblioteca/bibmidia/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_TIPOSDEMIDIANOVO_MENU_1300800299],
        },
        goesToMenu: true,
    },
]
